import React from "react";

import TopNav from "./TopNav";

// Brand OS shell — top-nav edition (2026-10-14).
//
// Keeps the same public API as the pre-redesign Shell: pages render
// `<Shell title="…">children</Shell>` and get the chrome for free.
// The old left sidebar + per-page topbar have been merged into a single
// slim top navigation. Pages gain the full page width underneath.
//
// `title` is kept in the signature for backward compatibility and is
// surfaced as the H1 above the page content so screen readers and the
// browser tab-strip behaviour stay unchanged. Pages that already render
// their own H1 can safely ignore it.
export default function Shell({ title, children }) {
  return (
    <div className="bo-root">
      <div className="bo-shell" data-testid="brand-os-shell">
        <TopNav />
        <main className="bo-main">
          {title ? (
            <div className="bo-page-title-strip" data-testid="brand-os-page-title">
              <h1 className="bo-page-title">{title}</h1>
            </div>
          ) : null}
          <section className="bo-content">{children}</section>
        </main>
      </div>
    </div>
  );
}
